import * as React from 'react';
import { useIsMac } from './useIsMac';

export function useShortcut(key: string, fn: (e: any) => void) {
    const isMac = useIsMac();
    const onKeydown = React.useCallback(
        (e: KeyboardEvent) => {
            if (e.key === key && ((isMac && e.metaKey) || (!isMac && e.ctrlKey))) {
                fn(e);
            }
        },
        [key, fn]
    );

    React.useEffect(() => {
        document.addEventListener('keydown', onKeydown, false);

        return () => {
            document.removeEventListener('keydown', onKeydown, false);
        };
    }, [key, fn, onKeydown]);
}
